import { supabase, getUid } from "./supabase";
import { enqueue } from "./outbox";
import { cacheGet, cacheSet } from "./dataCache";

/* Card-value drill stats (Pro). Writes go through cardval_record (is_pro-gated);
   reads through cardval_summary (own-row). Best-effort from the UI — a failed
   batch just means a few cards aren't tallied, never a broken drill. */

export async function recordCardValsRaw(deltas) {
  const { error } = await supabase.rpc("cardval_record", { p_deltas: deltas });
  if (error) {
    console.warn("cardval_record failed:", error.message);
    return false;
  }
  return true;
}

export async function recordCardVals(deltas) {
  if (!deltas || deltas.length === 0) return { ok: false };
  const ok = await recordCardValsRaw(deltas);
  // Additive deltas → queue per call so an offline batch replays exactly once.
  if (!ok) enqueue({ kind: "cardval", payload: { deltas } });
  return { ok };
}

export async function getCardValSummary(system, mode = "single") {
  const uid = await getUid();
  const key = uid ? `cardvalSummary:${uid}:${system}:${mode}` : null;
  const { data, error } = await supabase.rpc("cardval_summary", { p_system: system, p_mode: mode });
  if (error) {
    console.warn("cardval_summary failed:", error.message);
    return cacheGet(key) ?? null;
  }
  if (key) cacheSet(key, data);
  return data;
}
